<template>
  <div>
    <section class="report-title" style="padding:20px">
      <h5 id="modal-synthese___BV_modal_title_" class="modal-title">Complétude du dossier décès</h5>
      <h5>Assuré : {{ dossier.prenom }} {{ dossier.nom }}</h5>
    </section>
    <section class="report-content" style="padding: 10px 25px 10px 20px">
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">1</b-badge> <b>Identification assuré</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">N° SS</b> : <span class="ml-3">{{ dossier.nir }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Date du décès</b> : <span class="ml-3">{{ formatDateSynthese(dossier.fiche_deces.date_deces) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Cause décès</b> : <span class="ml-3" v-if="dossier.fiche_deces.cause_deces === 'mort_naturelle'">Mort naturelle</span><span class="ml-3" v-if="!isEmpty(dossier.fiche_deces.cause_deces) && dossier.fiche_deces.cause_deces !== 'mort_naturelle'">{{ dossier.fiche_deces.cause_deces[0].toUpperCase() + dossier.fiche_deces.cause_deces.substring(1) }}</span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">2</b-badge> <b>Couverture prévoyance</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-12">L'assuré remplit-il les conditions pour bénéficier du contrat de prévoyance ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.is_elligible_contrat_prevoyance === true ? 'Oui' : (dossier.fiche_deces.is_elligible_contrat_prevoyance === false ? 'Non' : '') }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-12">L'assuré bénéficiait-il de la portabilité ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.has_portabilite ? 'Oui' : (dossier.fiche_deces.has_portabilite === false ? 'Non' : '') }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-12">L'assuré était-il en suspension du contrat de travail ou bénéficiait-il d'un accord sénior ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.suspention_contrat === 'tp' ? 'Oui à temps partiel' : (dossier.fiche_deces.suspention_contrat === 'tc' ? 'Oui à temps complet' : (dossier.fiche_deces.suspention_contrat === 'non' ? 'Non' : '')) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-12">Avait-il souscrit à l'option maintien des garanties décès ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.has_option_maintien_garantie ? 'Oui' : (dossier.fiche_deces.has_option_maintien_garantie === false ? 'Non' : '') }}</span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <section class="report-content" style="padding: 10px 25px 10px 20px">
      <b-row class="pb-2">
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">3</b-badge> <b>Situation de l'assuré au Décès</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">L'assuré était-il toujours salarié ?</b> <span class="ml-2">{{ dossier.fiche_deces.was_salarie === true ? 'Oui' : (dossier.fiche_deces.was_salarie === false ? 'Non' : '') }}</span>
              </div>
              <div v-if="dossier.fiche_deces.was_salarie === false">
                <b class="d-inline-block col-sm-6">Si non, indiquer la date de RUPC</b> <span class="ml-2">{{ formatDateSynthese(dossier.fiche_deces.date_rupc) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">L'assuré avait-il un dossier en cours à la date du décès ?</b> <span class=" ml-2">{{ dossier.fiche_deces.had_dossier_en_cours === true ? 'Oui' : (dossier.fiche_deces.had_dossier_en_cours === false ? 'Non' : '') }}</span>
              </div>
              <div v-if="dossier.fiche_deces.had_dossier_en_cours === true">
                <b class="d-inline-block col-sm-6">Si oui, préciser </b> : <span class="ml-2">{{ dossier.fiche_deces.type_dossier_en_cours === 'ij' ? 'IJ' : (dossier.fiche_deces.type_dossier_en_cours === 'inval-1-2' ? 'Inval 1ère / 2ème' : (dossier.fiche_deces.type_dossier_en_cours === 'inval-3' ? 'Inval 3ème' : '')) }}</span>
              </div>
              <div v-if="dossier.fiche_deces.had_dossier_en_cours === true">
                <b class="d-inline-block col-sm-6">Date fait générateur</b> : <span class="ml-2">{{ formatDateFinPeriode(dossier.fiche_deces.date_fait_generateur) }}</span>
              </div>
              <div v-if="dossier.fiche_deces.had_dossier_en_cours === true">
                <b class="d-inline-block col-sm-6">Dernier jour payé</b> : <span class="ml-2">{{ formatDateFinPeriode(dossier.fiche_deces.date_dernier_jour_paye) }}</span>
              </div>
              <div v-if="dossier.fiche_deces.type_dossier_en_cours === 'inval-3'">
                <b class="d-inline-block col-sm-6">Si inval. 3ème catégorie, le capital IAD a-t-il été versé ?</b> : <span class="ml-2">{{ dossier.fiche_deces.has_capital_iad_verse === true ? 'Oui' : (dossier.fiche_deces.has_capital_iad_verse === false ? 'Non' : '') }}</span> <b v-if="dossier.fiche_deces.has_capital_iad_verse === true" class="text-danger">REFUS</b>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">4</b-badge> <b>Mise à jour NSI</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-12">Le dossier est-il à jour des règlements ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.is_reglement_a_jour === true ? 'Oui' : (dossier.fiche_deces.is_reglement_a_jour === false ? 'Non' : '') }}</span>
              </div>
              <div v-if="dossier.fiche_deces.is_reglement_a_jour === false">
                <b class="d-inline-block col-sm-12">Si non, préciser :</b>
                <span class="col-sm-12 ml-2">{{
                  dossier.fiche_deces.precision_non_a_jour === 'complement_notaire' ? 'Paiement complémentaire à faire au notaire' : (
                  dossier.fiche_deces.precision_non_a_jour === 'complement_employeur' ? 'Paiement complémentaire à faire à l\'employeur' : (
                  dossier.fiche_deces.precision_non_a_jour === 'indu_notaire' ? 'Indu à réclamer au notaire' : (
                  dossier.fiche_deces.precision_non_a_jour === 'indu_employeur' ? 'Indu à réclamer à l\'employeur' : ''))) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-12">La date du fait générateur est-elle à enregistrer dans NSI ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.is_fait_generateur_a_enregistrer_nsi === true ? 'Oui' : (dossier.fiche_deces.is_fait_generateur_a_enregistrer_nsi === false ? 'Non' : '') }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Numéro évènement décès NSI</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_evenement_nsi }}</span>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <section class="report-content" style="padding: 10px 25px 10px 20px">
      <b-row class="pb-2">
        <b-col sm="12" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">5</b-badge> <b>Concernant les bénéficiaires du capital</b></span>
            </div>
            <b-card-text class="d-inline-block p-1 col-sm-6">
              <div>
                <b class="d-inline-block col-sm-6">Numéro de SIRET</b> : <span class="ml-2">{{ dossier.siren }} {{ dossier.nic }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">N° contrat Base</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_contrat_base }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(dossier.fiche_deces.famille_produit_id_contrat_base) }}</i></span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">N° contrat Option</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_contrat_option }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(dossier.fiche_deces.famille_produit_id_contrat_option) }}</i></span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">N° contrat Option 2</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_contrat_option2 }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(dossier.fiche_deces.famille_produit_id_contrat_option2) }}</i></span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Statut de l'assuré</b> : <span class="ml-2">{{
                  dossier.fiche_deces.statut_assure === 'cadre' ? 'Cadre' : (
                  dossier.fiche_deces.statut_assure === 'non_cadre' ? 'Non cadre' : (
                  dossier.fiche_deces.statut_assure === 'th' ? 'TH' : '')) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Bénéficiait-il d'un contrat TB Médéric ?</b> : <span class=" ml-2">{{ dossier.fiche_deces.has_tb_mederic === true ? 'Oui' : (dossier.fiche_deces.has_tb_mederic === false ? 'Non' : '') }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Avait-il plusieurs employeurs ?</b> : <span class=" ml-2">{{ dossier.fiche_deces.is_multi_siren === true ? 'Oui' : (dossier.fiche_deces.is_multi_siren === false ? 'Non' : '') }}</span>
              </div>
            </b-card-text>
            <b-card class="d-inline-block card-employeur-synthese col-sm-6" v-for="(employeur,id) in dossier.deces_employeur" :key="id">
              <div>
                <b class="d-inline-block col-sm-6">Numéro de SIRET</b> : <span class="ml-2">{{ employeur.siren }} {{ employeur.nic }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">N° contrat Base</b> : <span class="ml-2">{{ employeur.numero_contrat_base }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(employeur.famille_produit_id_base) }}</i></span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">N° contrat Option</b> : <span class="ml-2">{{ employeur.numero_contrat_option }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(employeur.famille_produit_id_option) }}</i></span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Statut de l'assuré</b> : <span class="ml-2">{{
                  employeur.statut_assure === 'cadre' ? 'Cadre' : (
                  employeur.statut_assure === 'non_cadre' ? 'Non cadre' : (
                  employeur.statut_assure === 'th' ? 'TH' : '')) }}</span>
              </div>
              <div>
                <b class="d-inline-block col-sm-6">Bénéficiait-il d'un contrat TB Médéric ?</b> : <span class=" ml-2">{{ employeur.has_tb_mederic === true ? 'Oui' : (employeur.has_tb_mederic === false ? 'Non' : '') }}</span>
              </div>
            </b-card>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <section class="report-content" style="padding: 10px 25px 10px 20px">
      <b-row>
        <b-col sm="6" class="pl-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">6</b-badge> <b>Vérification exclusions</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-12">Les clauses d'exclusion prévues par le contrat sont-elles avérées ?</b> <span class="col-sm-12 ml-2">{{ dossier.fiche_deces.is_clauses_exclusion_averees === true ? 'Oui' : (dossier.fiche_deces.is_clauses_exclusion_averees === false ? 'Non' : '') }}</span>
              </div>
              <span v-if="dossier.fiche_deces.is_clauses_exclusion_averees === true" class="text-danger font-weight-bold" style="font-size: 1.3em;">{{ refus }}</span>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col sm="6" class="pl-0 pr-0">
          <b-card no-body class="full-width h-100 mb-0">
            <div class="card-smallHeader" style="background-color: #C8A7B4;">
              <span><b-badge variant="warning" class="mr-2">7</b-badge> <b>Vérification REC</b></span>
            </div>
            <b-card-text class="p-1">
              <div>
                <b class="d-inline-block col-sm-6">Le contrat est-il résilié ?</b> : <span class=" ml-2">{{ dossier.fiche_deces.is_contrat_resilie === true ? 'Oui' : (dossier.fiche_deces.is_contrat_resilie === false ? 'Non' : '') }}</span>
              </div>
              <div v-if="dossier.fiche_deces.is_contrat_resilie === true">
                <div>
                  <b class="d-inline-block col-sm-6">Si oui, préciser le motif </b> :
                  <span class="ml-2">{{
                    dossier.fiche_deces.motif_resiliation === 'fusion' ? 'Fusion/Absorption' : (
                    dossier.fiche_deces.motif_resiliation === 'demande_souscripteur' ? 'Demande contractuelle du souscripteur' : (
                    dossier.fiche_deces.motif_resiliation === 'regroupement' ? 'Regroupement de gestion' : (
                    dossier.fiche_deces.motif_resiliation === 'autre' ? 'Autre :' : ''))) }}</span>
                  <span v-if="dossier.fiche_deces.motif_resiliation === 'autre'" class="ml-2">( {{dossier.fiche_deces.motif_resiliation_autre}} )</span>
                </div>
                <div>
                  <b class="d-inline-block col-sm-6">La fermeture a-t-elle été effectuée à niveau atteint ?</b> : <span class=" ml-2">{{ dossier.fiche_deces.is_fermeture_effectuee_niveau_atteint === true ? 'Oui' : (dossier.fiche_deces.is_fermeture_effectuee_niveau_atteint === false ? 'Non' : '') }}</span>
                </div>
                <div v-if="dossier.fiche_deces.is_fermeture_effectuee_niveau_atteint === true">
                  <div>
                    <b class="d-inline-block col-sm-6">Si oui, MEP nouveau contrat ?</b> : <span class=" ml-2">{{ dossier.fiche_deces.is_mep_nouveau_contrat === true ? 'Oui' : (dossier.fiche_deces.is_mep_nouveau_contrat === false ? 'Non' : '') }}</span>
                  </div>
                  <div v-if="dossier.fiche_deces.is_mep_nouveau_contrat === true">
                    <div>
                      <b class="d-inline-block col-sm-6">Numéro de SIRET</b> : <span class="ml-2">{{ dossier.fiche_deces.siren_nouveau_contrat }} {{ dossier.fiche_deces.nic_nouveau_contrat }}</span>
                    </div>
                    <div>
                      <b class="d-inline-block col-sm-6">N° contrat Base</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_nouveau_contrat_base }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(dossier.fiche_deces.famille_produit_id_nouveau_contrat_base) }}</i></span>
                    </div>
                    <div>
                      <b class="d-inline-block col-sm-6">N° contrat Option</b> : <span class="ml-2">{{ dossier.fiche_deces.numero_nouveau_contrat_option }}</span> <span class="ml-3"><i>{{ getLibelleFamilleProduit(dossier.fiche_deces.famille_produit_id_nouveau_contrat_option) }}</i></span>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
  import { isEmpty } from '@/utils/fileHelper';
  import VueHtml2pdf from "vue-html2pdf";

  export default {
    name: "SyntheseAssure",
    components: {
      VueHtml2pdf
    },
    data() {
      return {
        isEmpty
      }
    },
    props: ['dossier', 'dcFamilleProduitPdf'],
    created() {
    },
    mounted() {
    },
    methods: {
      formatDateSynthese(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "--/--/----";
      },
      formatDateFinPeriode(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      getLibelleFamilleProduit(familleId) {
        let familleProduit = this.dcFamilleProduitPdf.find(famille => parseInt(famille.value,10) === parseInt(familleId,10));
        return !isEmpty(familleProduit) ? familleProduit.text : '';
      },
    }
  }

</script>
